import { Screens } from './screens.enum';

export enum PermissionActions {
  schedulesCreate = 'schedules-create',
  schedulesUpdate = 'schedules-update',
  schedulesStatusCreate = 'schedules-status-create',
  schedulesStatusUpdate = 'schedules-status-update',
  holidaysCreate = 'holidays-create',
  holidaysUpdate = 'holidays-update',
  clientsCreate = 'clients-create',
  clientsUpdate = 'clients-update',
  treatmentsCreate = 'treatments-create',
  treatmentsUpdate = 'treatments-update',
  dentalTreatmentsCreate = 'dental-treatments-create',
  dentalTreatmentsUpdate = 'dental-treatments-update',
  modelsHealthCertificatesCreate = 'models-health-certificates-create',
  modelsHealthCertificatesUpdate = 'models-health-certificates-update',
  healthCertificatesCreate = 'health-certificates-create',
  healthCertificatesUpdate = 'health-certificates-update',
  modelsDocumentsCreate = 'models-documents-create',
  modelsDocumentsUpdate = 'models-documents-update',
  documentsCreate = 'documents-create',
  documentsUpdate = 'documents-update',
  modelFormsCreate = 'model-forms-create',
  modelFormsUpdate = 'model-forms-update',
  formsCreate = 'forms-create',
  formsUpdate = 'forms-update',
  formsQuiz = 'forms-quiz',
  proceduresCreate = 'procedures-create',
  proceduresUpdate = 'procedures-update',
  financialsPlansCreate = 'financials-plans-create',
  financialsPlansUpdate = 'financials-plans-update',
  paymentsMethodsCreate = 'payments-methods-create',
  paymentsMethodsUpdate = 'payments-methods-update',
  financialsCreate = 'financials-create',
  financialsUpdate = 'financials-update',
  financialsPay = 'financials-pay',
  financialsCancel = 'financials-cancel',
  guidesStatusCreate = 'guides-status-create',
  guidesStatusUpdate = 'guides-status-update',
  guidesCreate = 'guides-create',
  guidesUpdate = 'guides-update',
  specialtiesCreate = 'specialties-create',
  specialtiesUpdate = 'specialties-update',
  terminologiesCreate = 'terminologies-create',
  terminologiesUpdate = 'terminologies-update',
  professionalsCreate = 'professionals-create',
  professionalsUpdate = 'professionals-update',
  professionalsResetSignaturePassword = 'professionals-reset-signature-password',
  covenantsCreate = 'covenants-create',
  covenantsUpdate = 'covenants-update',
  usersCreate = 'users-create',
  usersUpdate = 'users-update',
  usersResetPassword = 'users-reset-password',
  accessGroupsCreate = 'access-groups-create',
  accessGroupsUpdate = 'access-groups-update',
  accessGroupsPermissions = 'access-groups-permissions',
  companyCreate = 'company-create',
  companyUpdate = 'company-update',
  taxesCreate = 'taxes-create',
  taxesUpdate = 'taxes-update',
  productsCategoriesCreate = 'products-categories-create',
  productsCategoriesUpdate = 'products-categories-update',
  productsCreate = 'products-create',
  productsUpdate = 'products-update',
  inventoriesEntryCreate = 'inventories-entry-create',
  inventoriesOutputCreate = 'inventories-output-create',
  crmCampaignsCreate = 'crm-campaigns-create',
  crmCampaignsUpdate = 'crm-campaigns-update',
  crmCampaignsSend = 'crm-campaigns-send',
  crmTemplatesCreate = 'crm-templates-create',
  crmTemplatesUpdate = 'crm-templates-update',
  crmMessagingSendManual = 'crm-messaging-send-manual',
  crcContactsCreate = 'crc-contacts-create',
  crcContactsUpdate = 'crc-contacts-update',
  crcPendenciesResolve = 'crc-pendencies-resolve',
  crcReportsExport = 'crc-reports-export',
}

export const PERMISSIONS_DASHBOARD = [
  {
    label: '[Dashboard] Tela',
    value: Screens.dashboardView,
  },
];

export const PERMISSIONS_SCHEDULES = [
  {
    label: '[Agenda] Tela',
    value: Screens.schedulesView,
  },
  {
    label: '[Agenda] Cadastro',
    value: 'schedules-create',
  },
  {
    label: '[Agenda] Alteração',
    value: 'schedules-update',
  },
  {
    label: '[Status Agenda] Tela',
    value: Screens.schedulesStatusView,
  },
  {
    label: '[Status Agenda] Cadastro',
    value: 'schedules-status-create',
  },
  {
    label: '[Status Agenda] Alteração',
    value: 'schedules-status-update',
  },
  {
    label: '[Feriados] Tela',
    value: Screens.holidaysView,
  },
  {
    label: '[Feriados] Cadastro',
    value: 'holidays-create',
  },
  {
    label: '[Feriados] Alteração',
    value: 'holidays-update',
  },
];

export const PERMISSIONS_CLIENTS = [
  {
    label: '[Clientes/Fornecedores] Tela',
    value: Screens.clientsView,
  },
  {
    label: '[Clientes/Fornecedores] Cadastro',
    value: 'clients-create',
  },
  {
    label: '[Clientes/Fornecedores] Alteração',
    value: 'clients-update',
  },
];

export const PERMISSIONS_ODONTOLOGY = [
  {
    label: '[Odontologia] Tela',
    value: Screens.odontologyView,
  },
  {
    label: '[Odontologia] Cadastro',
    value: 'dental-treatments-create',
  },
  {
    label: '[Odontologia] Alteração',
    value: 'dental-treatments-update',
  },
];

export const PERMISSIONS_TREATMENTS = [
  {
    label: '[Tratamentos/Orçamentos] Tela',
    value: Screens.treatmentsView,
  },
  {
    label: '[Tratamentos/Orçamentos] Cadastro',
    value: 'treatments-create',
  },
  {
    label: '[Tratamentos/Orçamentos] Alteração',
    value: 'treatments-update',
  },
];

export const PERMISSIONS_HEALTH_CERTIFICATES = [
  {
    label: '[Modelos Atestados] Tela',
    value: Screens.modelsHealthCertificatesView,
  },
  {
    label: '[Modelos Atestados] Cadastro',
    value: 'models-health-certificates-create',
  },
  {
    label: '[Modelos Atestados] Alteração',
    value: 'models-health-certificates-update',
  },
  {
    label: '[Atestados] Tela',
    value: Screens.healthCertificatesView,
  },
  {
    label: '[Atestado] Cadastro',
    value: 'health-certificates-create',
  },
  {
    label: '[Atestado] Alteração',
    value: 'health-certificates-update',
  },
];

export const PERMISSIONS_DOCUMENTS = [
  {
    label: '[Modelo Documentos] Tela',
    value: Screens.modelsDocumentsView,
  },
  {
    label: '[Modelo Documento] Cadastro',
    value: 'models-documents-create',
  },
  {
    label: '[Modelo Documento] Alteração',
    value: 'models-documents-update',
  },
  {
    label: '[Documentos] Tela',
    value: Screens.documentsView,
  },
  {
    label: '[Documento] Cadastro',
    value: 'documents-create',
  },
  {
    label: '[Documento] Alteração',
    value: 'documents-update',
  },
];

export const PERMISSIONS_FORMS = [
  {
    label: '[Modelo Prontuários] Tela',
    value: Screens.modelsFormsView,
  },
  {
    label: '[Modelo Prontuário] Cadastro',
    value: 'model-forms-create',
  },
  {
    label: '[Modelo Prontuário] Alteração',
    value: 'model-forms-update',
  },
  {
    label: '[Prontuários] Tela',
    value: Screens.formsView,
  },
  {
    label: '[Prontuário] Cadastro',
    value: 'forms-create',
  },
  {
    label: '[Prontuário] Alteração',
    value: 'forms-update',
  },
  {
    label: '[Prontuário] Responder',
    value: 'forms-quiz',
  },
];

export const PERMISSIONS_PROCEDURES = [
  {
    label: '[Procedimentos] Tela',
    value: Screens.proceduresView,
  },
  {
    label: '[Prontuário] Cadastro',
    value: 'procedures-create',
  },
  {
    label: '[Prontuário] Alteração',
    value: 'procedures-update',
  },
];

export const PERMISSIONS_FINANCIALS = [
  {
    label: '[Plano de contas] Tela',
    value: Screens.financialsPlansView,
  },
  {
    label: '[Plano de contas] Cadastro',
    value: 'financials-plans-create',
  },
  {
    label: '[Plano de contas] Alteração',
    value: 'financials-plans-update',
  },
  {
    label: '[Formas de Pagamento] Tela',
    value: Screens.paymentsMethodsView,
  },
  {
    label: '[Formas de Pagamento] Cadastro',
    value: 'payments-methods-create',
  },
  {
    label: '[Formas de Pagamento] Alteração',
    value: 'payments-methods-update',
  },
  {
    label: '[Taxas] Tela',
    value: Screens.taxesView,
  },
  {
    label: '[Taxas] Cadastro',
    value: 'taxes-create',
  },
  {
    label: '[Taxas] Alteração',
    value: 'taxes-update',
  },
  {
    label: '[Movimentação Financeira] Tela',
    value: Screens.movementsFinancialsView,
  },
  {
    label: '[Controle de Caixa] Tela',
    value: Screens.cashRegisterView,
  },
  {
    label: '[Contas Pagar/Receber] Tela',
    value: Screens.financialsView,
  },
  {
    label: '[Contas Pagar/Receber] Cadastro',
    value: 'financials-create',
  },
  {
    label: '[Contas Pagar/Receber] Alteração',
    value: 'financials-update',
  },
  {
    label: '[Contas Pagar/Receber] Pagar',
    value: 'financials-pay',
  },
  {
    label: '[Contas Pagar/Receber] Cancelar',
    value: 'financials-cancel',
  },
];

export const PERMISSIONS_GUIDES = [
  {
    label: '[Status Guia] Tela',
    value: Screens.guidesStatusView,
  },
  {
    label: '[Status Guia] Cadastro',
    value: 'guides-status-create',
  },
  {
    label: '[Status Guia] Alteração',
    value: 'guides-status-update',
  },
  {
    label: '[Guia] Tela',
    value: Screens.guidesView,
  },
  {
    label: '[Guia] Cadastro',
    value: 'guides-create',
  },
  {
    label: '[Guia] Alteração',
    value: 'guides-update',
  },
];

export const PERMISSIONS_PROFESSIONALS = [
  {
    label: '[Especialidades] Tela',
    value: Screens.specialtiesView,
  },
  {
    label: '[Especialidades] Cadastro',
    value: 'specialties-create',
  },
  {
    label: '[Especialidades] Alteração',
    value: 'specialties-update',
  },
  {
    label: '[Terminologias] Tela',
    value: Screens.terminologiesView,
  },
  {
    label: '[Terminologias] Cadastro',
    value: 'terminologies-create',
  },
  {
    label: '[Terminologias] Alteração',
    value: 'terminologies-update',
  },
  {
    label: '[Profissionais] Tela',
    value: Screens.professionalsView,
  },
  {
    label: '[Profissionais] Cadastro',
    value: 'professionals-create',
  },
  {
    label: '[Profissionais] Alteração',
    value: 'professionals-update',
  },
  {
    label: '[Profissionais] Resetar Senha de Ass.',
    value: 'professionals-reset-signature-password',
  },
];

export const PERMISSIONS_COVENANTS = [
  {
    label: '[Convênios] Tela',
    value: Screens.covenantsView,
  },
  {
    label: '[Convênios] Cadastro',
    value: 'covenants-create',
  },
  {
    label: '[Convênios] Alteração',
    value: 'covenants-update',
  },
];

export const PERMISSIONS_USERS = [
  {
    label: '[Usuários] Tela',
    value: Screens.usersView,
  },
  {
    label: '[Usuários] Cadastro',
    value: 'users-create',
  },
  {
    label: '[Usuários] Alteração',
    value: 'users-update',
  },
  {
    label: '[Usuários] Resetar Senha',
    value: 'users-reset-password',
  },
  {
    label: '[Grupo de Acesso] Tela',
    value: Screens.accessGroupsView,
  },
  {
    label: '[Grupo de Acesso] Cadastro',
    value: 'access-groups-create',
  },
  {
    label: '[Grupo de Acesso] Alteração',
    value: 'access-groups-update',
  },
  {
    label: '[Grupo de Acesso] Permissões',
    value: 'access-groups-permissions',
  },
];

export const PERMISSIONS_COMPANY = [
  {
    label: '[Dados da Empresa] Tela',
    value: Screens.companyView,
  },
  {
    label: '[Dados da Empresa] Cadastro',
    value: 'company-create',
  },
  {
    label: '[Dados da Empresa] Alteração',
    value: 'company-update',
  },
];

export const PERMISSIONS_WHATSAPP = [
  {
    label: '[WhatsApp] Tela',
    value: Screens.whatsAppView,
  },
];

export const PERMISSIONS_CRM = [
  {
    label: '[CRM - Campanhas] Tela',
    value: Screens.crmCampaignsView,
  },
  {
    label: '[CRM - Campanhas] Cadastro',
    value: 'crm-campaigns-create',
  },
  {
    label: '[CRM - Campanhas] Alteração',
    value: 'crm-campaigns-update',
  },
  {
    label: '[CRM - Campanhas] Disparar / Enviar',
    value: 'crm-campaigns-send',
  },
  {
    label: '[CRM - Templates] Tela',
    value: Screens.crmTemplatesView,
  },
  {
    label: '[CRM - Templates] Cadastro',
    value: 'crm-templates-create',
  },
  {
    label: '[CRM - Templates] Alteração',
    value: 'crm-templates-update',
  },
  {
    label: '[CRM - Mensagens/Inbox] Tela',
    value: Screens.crmMessagingView,
  },
  {
    label: '[CRM - Mensagens] Enviar Manual',
    value: 'crm-messaging-send-manual',
  },
];

export const PERMISSIONS_CRC = [
  {
    label: '[CRC - Dashboard] Tela',
    value: Screens.crcDashboardView,
  },
  {
    label: '[CRC - Central de Contatos] Tela',
    value: Screens.crcContactsView,
  },
  {
    label: '[CRC - Contatos] Cadastro',
    value: 'crc-contacts-create',
  },
  {
    label: '[CRC - Contatos] Alteração',
    value: 'crc-contacts-update',
  },
  {
    label: '[CRC - Pendências] Tela',
    value: Screens.crcPendenciesView,
  },
  {
    label: '[CRC - Pendências] Resolver / Ações',
    value: 'crc-pendencies-resolve',
  },
  {
    label: '[CRC - Relatórios] Tela',
    value: Screens.crcReportsView,
  },
  {
    label: '[CRC - Relatórios] Exportar (PDF / Excel)',
    value: 'crc-reports-export',
  },
];

export const PERMISSIONS_INVENTORY = [
  {
    label: '[Categoria de Produtos] Tela',
    value: Screens.productsCategoriesView,
  },
  {
    label: '[Categoria de Produtos] Cadastro',
    value: 'products-categories-create',
  },
  {
    label: '[Categoria de Produtos] Alteração',
    value: 'products-categories-update',
  },
  {
    label: '[Produtos] Tela',
    value: Screens.productsView,
  },
  {
    label: '[Venda de Produtos] Tela',
    value: Screens.quickSaleView,
  },
  {
    label: '[Acompanhamento de Vendas] Tela',
    value: Screens.salesView,
  },
  {
    label: '[Produtos] Cadastro',
    value: 'products-create',
  },
  {
    label: '[Produtos] Alteração',
    value: 'products-update',
  },
  {
    label: '[Estoque] Tela',
    value: Screens.inventoriesView,
  },
  {
    label: '[Estoque] Cadastro de Entrada',
    value: 'inventories-entry-create',
  },
  {
    label: '[Estoque] Cadastro de Saída',
    value: 'inventories-output-create',
  },
];
